module.exports = __webpack_public_path__ + "static/media/fax2.cce0d67c.svg";